export const RBLIcon = () => (
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="rbl-icon"
  >
    <line
      x1="3.53572"
      y1="4.05028"
      x2="11.3139"
      y2="11.8285"
      stroke="#FFDE38"
      strokeWidth="2"
    />
    <rect
      y="4.75739"
      width="6"
      height="6"
      rx="2"
      transform="rotate(-45 0 4.75739)"
      fill="#FFDE38"
    />
    <rect
      x="8.48535"
      y="13.2427"
      width="6"
      height="6"
      rx="2"
      transform="rotate(-45 8.48535 13.2427)"
      fill="#FFDE38"
    />
  </svg>
);
